import { IApplicationState } from '../../types/redux';

export const selectListingSeoData = (state: IApplicationState) => {
  return state.listingOffers.seoData;
};
